export const SLIDEOUT_TYPE = {
	BUDGET_INSIGHT: 'budget-insight',
	PREDICTED_END_INSIGHT: 'predicted-end-insight',
	SUGGESTED_STATUS_INSIGHT: 'suggested-status-insight',
};
